"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ = require("./");
var _default = exports.default = {
  list: {
    path: 'downloadapp',
    icon: 'VDC_IconFont_Download',
    title: 'Download',
    private: true,
    level: 0,
    component: _.DownloadApp
  }
};
module.exports = exports.default;